import { useMutation } from '@apollo/client';

import UpdateLearnerOccupationPreferencesOrUnsure from 'bundles/onboarding-common/queries/UpdateLearnerOccupationPreferencesOrUnsure.graphql';
import type {
  UpdateLearnerOccupationPreferencesOrUnsureMutation,
  UpdateLearnerOccupationPreferencesOrUnsureMutationVariables,
} from 'bundles/onboarding-common/queries/__generated__/UpdateLearnerOccupationPreferencesOrUnsure';
import type { SelectedRole } from 'bundles/onboarding-common/types';

const useUpdateLearnerOccupationPreferencesOrUnsure = () => {
  const [updateLearnerOccupationPreferencesOrUnsureMutation] = useMutation<
    UpdateLearnerOccupationPreferencesOrUnsureMutation,
    UpdateLearnerOccupationPreferencesOrUnsureMutationVariables
  >(UpdateLearnerOccupationPreferencesOrUnsure, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
  });

  const updateLearnerOccupationPreferencesOrUnsure = async (answers?: SelectedRole[] | null) => {
    const isUnsureOfRoles = answers?.some((answer) => answer.type === 'UNSURE') ?? false;
    const occupationPreferences =
      !isUnsureOfRoles && answers
        ? answers.map((answer) => {
            const id = answer.id;
            const name = answer.name;
            const type = answer.type;
            if (type === 'CUSTOM') {
              return { occupation: { name } };
            }
            return { occupation: { id } };
          })
        : [];
    const variables: UpdateLearnerOccupationPreferencesOrUnsureMutationVariables = {
      occupationPreferences,
      isUnsureOfRoles: { booleanValue: isUnsureOfRoles },
    };

    const { errors, data } = await updateLearnerOccupationPreferencesOrUnsureMutation({
      variables,
    });

    if (errors) {
      return { success: false, errors: errors.map((error) => error.message) };
    }

    if (data?.LearnerProfile_PatchWorkPreferences.__typename === 'LearnerProfile_PatchFailure') {
      return { success: false, errors: data?.LearnerProfile_PatchWorkPreferences.errors.map((error) => error.message) };
    }

    return { success: true, errors: [] };
  };

  return { updateLearnerOccupationPreferencesOrUnsure };
};

export default useUpdateLearnerOccupationPreferencesOrUnsure;
